export default "__VITE_ASSET__CZcvVcmK__"